<!-- 新-订阅推送 - Email Alert订阅 -->
<template>
  <div class="new-subscribe-push-email-alert">
    <div class="page-layout">
      <!-- 左侧三级菜单 -->
      <div class="menu-sidebar" :class="{ 'is-collapsed': menuCollapsed }">
        <nested-menu
          :menu-list="subMenuList"
          :active-key="activeMenuKey"
          :is-collapsed="menuCollapsed"
          @item-click="handleMenuClick"
          @toggle-collapse="handleToggleCollapse"
        />
      </div>
      <!-- 右侧内容区域 -->
      <div class="content-area">
        <div class="page-content">
          <!-- 嵌套路由视图 -->
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NestedMenu from '@/components/nestedMenu'

export default {
  name: 'NewSubscribePushEmailAlert',
  components: {
    NestedMenu
  },
  data() {
    return {
      activeMenuKey: 'dy-fx', // 默认激活订阅分析
      currentMenuKey: 'dy-fx',
      // 菜单是否收起
      menuCollapsed: false,
      // 三级菜单数据
      subMenuList: [
        {
          id: 'dy-fx',
          label: '订阅分析',
          path: '/newSubscribePushEmailAlert/subscriptionAnalysis'
        },
        {
          id: 'ts-fx',
          label: '推送分析',
          path: '/newSubscribePushEmailAlert/pushAnalysis'
        }
      ]
    }
  },
  watch: {
    $route(to) {
      // 根据路由更新激活的菜单项
      const path = to.path
      const menuItem = this.subMenuList.find((item) =>
        path.includes(item.path.split('/').pop())
      )
      if (menuItem) {
        this.activeMenuKey = menuItem.id
        this.currentMenuKey = menuItem.id
      }
    }
  },
  mounted() {
    // 根据当前路由设置激活菜单
    this.updateActiveMenu()
  },
  methods: {
    handleMenuClick(item) {
      this.activeMenuKey = item.id
      this.currentMenuKey = item.id
      if (item.path) {
        const columnId = this.$route.query.columnId || '11-2' // 新-订阅推送 -> Email Alert订阅
        this.$router.push({
          path: item.path,
          query: {
            ...this.$route.query,
            columnId
          }
        })
      }
    },
    updateActiveMenu() {
      const path = this.$route.path
      const menuItem = this.subMenuList.find((item) =>
        path.includes(item.path.split('/').pop())
      )
      if (menuItem) {
        this.activeMenuKey = menuItem.id
        this.currentMenuKey = menuItem.id
      } else if (this.subMenuList.length > 0) {
        // 如果没有匹配的，默认跳转到第一个
        this.handleMenuClick(this.subMenuList[0])
      }
    },
    getCurrentMenuLabel() {
      const menuItem = this.subMenuList.find(
        (item) => item.id === this.currentMenuKey
      )
      return menuItem ? menuItem.label : ''
    },
    /**
     * 处理菜单收起/展开切换
     */
    handleToggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    }
  }
}
</script>

<style lang="scss" scoped>
.new-subscribe-push-email-alert {
  height: 100%;
  overflow: hidden;

  .page-layout {
    display: flex;
    height: 100%;
  }

  .menu-sidebar {
    width: 120px;
    background-color: #fff;
    border-right: 1px solid #e4e7ed;
    overflow: hidden;
    flex-shrink: 0;
    transition: width 0.3s ease;

    &.is-collapsed {
      width: 60px;
    }
  }

  .content-area {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .page-header {
      padding: 20px;
      border-bottom: 1px solid #e4e7ed;
      flex-shrink: 0;

      h2 {
        margin: 0;
        font-size: 18px;
        font-weight: 500;
        color: #303133;
      }
    }

    .page-content {
      flex: 1;
      overflow-y: auto;
    }

    .empty-content {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #909399;
      font-size: 14px;
    }
  }
}
</style>
